var map = {
	"./icon-1.svg": 28853,
	"./icon-10.svg": 46767,
	"./icon-11.svg": 84190,
	"./icon-2.svg": 87606,
	"./icon-3.svg": 74727,
	"./icon-4.svg": 54920,
	"./icon-5.png": 7973,
	"./icon-6.svg": 2090,
	"./icon-7.svg": 36283,
	"./icon-8.svg": 68668,
	"./icon-9.svg": 39293
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32746;